import { useQueryParams } from '@pocapan/shared/utils/useQueryParams';
import useArtistQuery from '../api/queries/useArtistQuery';

export const ReportPhotoCardBreadcrumb = () => {
  const { queryParams } = useQueryParams();

  const artist = useArtistQuery(queryParams.get('artistId'));
  const member = artist?.members?.find((member) => member.memberId === queryParams.get('memberId'));

  if (artist && member) {
    return (
      <div className="text-[15px] font-medium leading-[18px] text-left text-text-primary">
        {`${artist.name} ${member.name}`}
      </div>
    );
  }
};
